import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { ToasterComponent } from '@shared/components/toaster/toaster.component';
import { PwaUpdateService } from '@core/services/pwa-update.service';
import { AccessDeniedOverlayComponent, RouteLoaderComponent } from '@shared/components/ui';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, DialogModule, ToasterComponent, RouteLoaderComponent, AccessDeniedOverlayComponent],
  template: ` <app-route-loader />
    <router-outlet /> <app-toaster />
    <app-access-denied-overlay />
    <div kendoDialogContainer></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly pwaUpdate = inject(PwaUpdateService);

  ngOnInit(): void {
    this.pwaUpdate.init();
  }
}
